export const ONBOARDING = {
  // training_card: {
  //   text: 'Training cards let you practice basic football skills',
  //   vo: 'onboarding_card_training',
  //   side: 'bottom',
  //   position: { x: 840, y: 650 },
  // },
};

// set the default duration of the speech bubbles ( ONBOARDING_DEFAULT_TIME * { number or characters } )
export const ONBOARDING_DEFAULT_TIME = 1;
// increase the speed of all onboarding... 1 = default, 0.5 = half speed, 2 = double speed
export const ONBOARDING_SPEED = 1; // 1 = default, then x2, x3 etc...
